import { isNumber } from 'angular';
import * as d3 from 'd3';

export let CngBarChartDirective = () => {
  function link(scope, elem, attr) {
    scope.$watch(attr.chartData, value => {
      d3.select(elem[0]).selectAll('.bar').remove();

      let container = d3.select(elem[0]);
      let ranges: any[] = [];
      let color: any;
      let barScale: any;
      let data: any[] = [];
      let category: any;

      for (category in value) {
        if (value.hasOwnProperty(category) && isNumber(value[category])) {
          data.push(value[category]);
          ranges.push(category);
        }
      }

      color = d3.scaleOrdinal().range(ranges);
      barScale = d3
        .scaleLinear()
        .domain([0, d3.max(data)])
        .range([0, 100]);

      container
        .selectAll('.bar')
        .data(data)
        .enter()
        .append('div')
        .attr('class', (_, i) => 'bar ' + color(i))
        .style('width', d => barScale(d) + '%')
        .append('span')
        .text(d => d);
    });

    // fix to prevent memory leak
    scope.$on('$destroy', () => {
      // remove listener
    });
    elem.on('$destroy', () => {
      scope.$destroy();
    });
  }

  return {
    restrict: 'E',
    transclude: false,
    template: '<div></div>',
    link: link,
    replace: true,
  };
};

export default 'cngBarChart';
